import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { setScenesData } from "../../utils/setdata";
import { IScene } from "../../types/interface";

interface ScenesState {
  currentScene: IScene;
  statusScene: string;
  isRain: boolean;
  isDay: boolean;
}

const initialState: ScenesState = {
  currentScene: setScenesData[0],
  statusScene: setScenesData[0].scenesType.status.default,
  isRain: false,
  isDay: false,
};

export const scenesSlice = createSlice({
  name: "scenes",
  initialState,
  reducers: {
    getSourceScenes: (state, action: PayloadAction<IScene>) => {
      state.currentScene = action.payload;
      state.statusScene = state.currentScene.scenesType?.status?.default;
      state.isRain = false;
      state.isDay = false;
    },
    setRain: (state) => {
      state.isRain = !state.isRain;
      if (state.isDay && !state.isRain) {
        state.statusScene = state.currentScene.scenesType?.status?.night;
      } else if (state.isDay && state.isRain) {
        state.statusScene = state.currentScene.scenesType?.status?.rainNight;
      } else if (!state.isDay && !state.isRain) {
        state.statusScene = state.currentScene.scenesType?.status?.default;
      } else if (!state.isDay && state.isRain) {
        state.statusScene = state.currentScene.scenesType?.status?.rainDay;
      }
    },
    setStatusScene: (state) => {
      state.isDay = !state.isDay;
      if (state.isDay) {
        if (!state.isRain) {
          state.statusScene = state.currentScene.scenesType?.status?.night;
        } else {
          state.statusScene = state.currentScene.scenesType?.status?.rainNight;
        }
      } else {
        if (!state.isRain) {
          state.statusScene = state.currentScene.scenesType?.status?.default;
        } else {
          state.statusScene = state.currentScene.scenesType?.status?.rainDay;
        }
      }
    },
  },
});

export const { getSourceScenes, setStatusScene, setRain } = scenesSlice.actions;

export default scenesSlice.reducer;
